import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "Popover",
  props: {
    placement: {
      type: String,
      default: "top"
    }
  },
  data() {
    return {
      visible: false,
      eventNamespace: _parseInt(Math.random() * 1000)
    };
  },
  mounted() {
    this.bindOutsideClick();
    this.bindRootEvents();
  },
  beforeDestroy() {
    this.unBindOutsideClick();
    this.unBindRootEvents();
  },
  methods: {
    show() {
      this._closeOpenedPopovers();
      this.closeNavbarIfVisible();
      this.visible = true;
      this.$emit("shown");
    },
    hide() {
      this.visible = false;
      this.$emit("hidden");
    },
    hideSilently() {
      this.visible = false;
    },
    _silentlyHide(event, callerNamespace = null) {
      if (!callerNamespace || Number(callerNamespace) !== this.eventNamespace) {
        this.hideSilently();
      }
    },
    _closeOpenedPopovers() {
      $("body").trigger("popover:close", [this.eventNamespace]);
    },
    toggle(visible = !this.visible) {
      if (visible) this.show();else this.hide();
    },
    handleOutsideClick(event) {
      if (!this.visible) return;
      event.stopPropagation();
      const target = $(event.target);
      if (target.hasClass("ignore-popover")) return;
      const popoverContainer = $(this.$refs.popoverContainer);
      if (!target.exists() || !popoverContainer.exists()) return;
      if (!$.contains(popoverContainer[0], target[0])) {
        this.hide();
      }
    },
    bindOutsideClick() {
      $(document).on("mousedown touchstart", this.handleOutsideClick.bind(this));
    },
    unBindOutsideClick() {
      $(document).off("mousedown touchstart", this.handleOutsideClick);
    },
    bindRootEvents() {
      this.$root.$on("popover:close", this.hide);
      $(document).on(`popover:close.${this.eventNamespace}`, this._silentlyHide);
    },
    unBindRootEvents() {
      this.$root.$off("popover:close", this.hide);
      $(document).off(`popover:close.${this.eventNamespace}`, this._silentlyHide);
    },
    closeNavbarIfVisible() {
      const navbarToggle = $(".navbar-toggler");
      if (navbarToggle.is(":visible")) navbarToggle.click();
    }
  }
});